import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Sparkles, Plus } from 'lucide-react';

const SpaTab = ({
  products,
  allRecommendations,
  addToCart,
  language
}) => {
  const spaProducts = products.filter(p => p.category === 'spa');

  return (
    <div className="space-y-4">
      {/* Spa recommendations */}
      {allRecommendations.spa?.length > 0 && (
        <Card className="bg-gradient-to-r from-purple-50 to-pink-50 border-purple-200">
          <CardContent className="p-4">
            <h3 className="font-semibold text-purple-800 mb-3 flex items-center gap-2">
              <span className="text-lg">⭐</span>
              {language === 'fr' ? 'Soins Spa recommandés pour ce diagnostic' : 'Recommended Spa treatments for this diagnosis'}
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
              {allRecommendations.spa.slice(0, 4).map(product => (
                <Card key={product.id} className="bg-white border-purple-100 hover:shadow-md transition-shadow">
                  <CardContent className="p-3">
                    <div className="text-center">
                      <div className="w-12 h-12 mx-auto mb-2 bg-purple-50 rounded-full flex items-center justify-center">
                        <Sparkles className="w-6 h-6 text-purple-600" />
                      </div>
                      <p className="text-xs font-medium text-[#5D4E37] line-clamp-2 mb-1">{product.name}</p>
                      <p className="text-sm font-bold text-purple-600">{product.price?.toLocaleString()} F</p>
                      <Button 
                        size="sm" 
                        className="mt-2 w-full bg-purple-600 hover:bg-purple-700 text-white text-xs h-7"
                        onClick={() => addToCart(product)}
                      >
                        <Plus className="w-3 h-3 mr-1" />
                        {language === 'fr' ? 'Ajouter' : 'Add'}
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </CardContent>
        </Card>
      )}

      {/* Spa info banner */}
      <Card className="border-purple-200 bg-purple-50">
        <CardContent className="p-4">
          <div className="flex items-center gap-2 mb-2">
            <Sparkles className="w-5 h-5 text-purple-600" />
            <h3 className="font-semibold text-purple-800">
              {language === 'fr' ? 'Soins et accessoires Spa' : 'Spa care and accessories'}
            </h3>
          </div>
          <p className="text-sm text-purple-700 mb-3">
            {language === 'fr' 
              ? 'Gommages, masques, gants et accessoires pour une routine de soin professionnelle.'
              : 'Scrubs, masks, gloves and accessories for a professional skincare routine.'
            }
          </p>
        </CardContent>
      </Card>

      {/* Spa products list */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {spaProducts.map(product => (
          <Card key={product.id} className="bg-white border-[#E7E5E4] hover:shadow-lg transition-shadow">
            <CardContent className="p-4">
              <div className="w-14 h-14 mx-auto mb-3 bg-purple-50 rounded-full flex items-center justify-center">
                <Sparkles className="w-7 h-7 text-purple-500" />
              </div>
              <h3 className="text-sm font-medium text-[#0F172A] text-center line-clamp-2 mb-1">{product.name}</h3>
              <p className="text-center font-bold text-purple-600 mb-3">{product.price?.toLocaleString()} F</p>
              <Button 
                size="sm" 
                className="w-full bg-purple-600 hover:bg-purple-700"
                onClick={() => addToCart(product)}
              >
                <Plus className="w-4 h-4 mr-1" />
                {language === 'fr' ? 'Ajouter' : 'Add'}
              </Button>
            </CardContent>
          </Card>
        ))}
        {spaProducts.length === 0 && (
          <div className="col-span-full text-center py-8 text-[#78716C]">
            {language === 'fr' ? 'Aucun produit Spa disponible' : 'No Spa products available'}
          </div>
        )}
      </div>
    </div>
  );
};

export default SpaTab;
